import { Link, useLocation } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <PageLayout>
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="font-label text-6xl font-bold tracking-tight text-background-300 md:text-8xl">404</span>
        <h1 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">页面不存在或已下线</h1>
        <p className="mt-2 max-w-md text-sm leading-7 text-foreground-500">
          你访问的地址 <span className="text-foreground-700">{location.pathname}</span> 暂时没有内容，可以回到首页或去影视分类页继续浏览。
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-primary-950 transition-colors hover:bg-accent-400 cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600 cursor-pointer whitespace-nowrap"
          >
            浏览影视分类
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}